import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseDeletePublicCompanyLeadContactProps {
  contactId?: string
  onSuccess: () => void
  onError: () => void
}

export const useDeletePublicCompanyLeadContact = ({
  contactId,
  onSuccess,
  onError,
}: UseDeletePublicCompanyLeadContactProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deletePublicCompanyLeadContact'],
    mutationFn: async () => {
      await privateAxios.delete(`/funnel/contacts/${contactId}`)
    },
    onSuccess,
    onError,
  })
}
